(function () {
  var mark = document.querySelector('[data-zh-mark]');
  var bar = document.querySelector('[data-zh-bar]');
  var ph = document.querySelector('[data-zh-ph]');
  var tag = document.querySelector('[data-zh-tag]');
  var strip = document.querySelector('.zh-strip');
  document.addEventListener('touchstart', function (ev) {
    var card = ev.target.closest && ev.target.closest('.zcard');
    if (card) card.classList.add('is-touch');
  }, { passive: true });
  ['touchend', 'touchcancel', 'touchmove'].forEach(function (t) {
    document.addEventListener(t, function () {
      document.querySelectorAll('.zcard.is-touch').forEach(function (c) { c.classList.remove('is-touch'); });
    }, { passive: true });
  });
  if (!mark || !bar) return;
  var span = mark.querySelector('span');
  var ticking = false;
  function small() { return window.innerWidth < 750 ? 22 : 40; }
  function update() {
    ticking = false;
    var y = window.scrollY || document.documentElement.scrollTop || 0;
    var stripH = strip ? strip.offsetHeight : 0;
    var barTop = Math.max(0, stripH - y);
    document.documentElement.style.setProperty('--zh-top', barTop + 'px');
    var s = small();
    if (!ph) {
      var h = span.offsetHeight || s;
      mark.style.transform = 'translateY(' + (barTop + (64 - h) / 2) + 'px)';
      return;
    }
    var big = parseFloat(getComputedStyle(span).fontSize) || 140;
    var p = Math.min(1, Math.max(0, y / 420));
    var e = 1 - Math.pow(1 - p, 2);
    var nat = ph.getBoundingClientRect().top;
    var target = barTop + (64 - s) / 2;
    var top = nat * (1 - e) + target * e;
    var scale = 1 + (s / big - 1) * e;
    mark.style.transform = 'translateY(' + top.toFixed(1) + 'px) scale(' + scale.toFixed(4) + ')';
    if (tag) tag.style.opacity = Math.max(0, 1 - p * 3).toFixed(2);
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
  update();
  document.addEventListener('click', function (ev) {
    var menu = document.querySelector('.zh-menu[open]');
    if (menu && (ev.target.closest('.zh-menu nav a') || !ev.target.closest('.zh-menu'))) menu.removeAttribute('open');
  });
})();

/* Display-only currency conversion. Checkout stays in USD. */
(function () {
  var SYM = { USD: '$', EUR: '€', GBP: '£', AUD: 'A$', CAD: 'C$', ILS: '₪' };
  var FALLBACK = { USD: 1, EUR: 0.92, GBP: 0.78, AUD: 1.52, CAD: 1.37, ILS: 3.7 };
  var SEL = '.zcard-price, .price-item, .price__regular, .price__sale, .totals__total-value, .cart-item__price-wrapper, .cart-item__final-price, .product-option dd, .cart-drawer .totals';
  var RX = /\$\s?([\d,]+(?:\.\d{1,2})?)(\s?USD)?/g;
  var store = { get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } }, set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };
  var rates = FALLBACK, cur = store.get('zeme_cur') || 'USD';
  function fmt(usd) { var v = usd * (rates[cur] || 1); return SYM[cur] + Math.round(v).toLocaleString('en-US'); }
  function walk(root) {
    var els = root.querySelectorAll ? root.querySelectorAll(SEL) : [];
    els.forEach(function (el) {
      var tw = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var n; while ((n = tw.nextNode())) {
        if (n.__zOrig === undefined) { if (!/\$\s?\d/.test(n.nodeValue)) continue; n.__zOrig = n.nodeValue; }
        var o = n.__zOrig;
        var next = cur === 'USD' ? o : o.replace(RX, function (m, num) { return fmt(parseFloat(num.replace(/,/g, ''))); });
        if (n.nodeValue !== next) n.nodeValue = next;
      }
    });
  }
  function label() {
    document.querySelectorAll('[data-zh-cur-label]').forEach(function (l) { l.textContent = cur + ' ' + SYM[cur]; });
    document.querySelectorAll('[data-cur]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-cur') === cur ? 'true' : 'false'); });
  }
  function apply() { label(); walk(document); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cur]');
    if (b) { cur = b.getAttribute('data-cur'); store.set('zeme_cur', cur); apply(); var d = b.closest('details'); if (d) d.removeAttribute('open'); return; }
    var open = document.querySelector('.zh-cur[open]');
    if (open && !e.target.closest('.zh-cur')) open.removeAttribute('open');
  });
  var cached = store.get('zeme_rates'), stamp = +(store.get('zeme_rates_t') || 0);
  if (cached && Date.now() - stamp < 864e5) { try { rates = JSON.parse(cached); } catch (e) {} }
  else {
    fetch('https://open.er-api.com/v6/latest/USD').then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.rates) { var r = {}; Object.keys(SYM).forEach(function (k) { r[k] = d.rates[k] || FALLBACK[k]; }); rates = r; store.set('zeme_rates', JSON.stringify(r)); store.set('zeme_rates_t', String(Date.now())); apply(); }
    }).catch(function () {});
  }
  var pending = false;
  new MutationObserver(function () { if (cur === 'USD' || pending) return; pending = true; requestAnimationFrame(function () { pending = false; walk(document); }); }).observe(document.body, { childList: true, subtree: true, characterData: false });
  apply();
})();
